import { makeAutoObservable } from "mobx";
import { TariffPlan } from "@type/tariffPlan";
import { tariffPlanService } from "@api/services/tariffPlanService";

class TariffPlanStore {
  tariffPlans: TariffPlan[] | null = null;
  isListLoading = false;

  setIsListLoading = (value: boolean) => (this.isListLoading = value);

  setTariffPlans = (value: TariffPlan[]) => (this.tariffPlans = value);

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async loadList() {
    if (this.isListLoading) return;

    this.setIsListLoading(true);
    try {
      const { data } = await tariffPlanService.getList();
      this.setTariffPlans(data);
    } catch (error) {
      console.error(error);
    } finally {
      this.setIsListLoading(false);
    }
  }
}

export const tariffPlanStore = new TariffPlanStore();
